angular.module('wbDashboard').controller('PlansInfoFeatureControllerAurea', ['$scope', '$uibModal', '$q', 'User', 'Message', function ($scope, $uibModal, $q, User, Message) {

    $scope.$watch('plan', function(plan) {
        if (plan) {
            angular.forEach(plan.features, function(feature) {
                if (feature.slug === $scope.$stateParams.fslug) {
                    $scope.feature = feature;
                }
            });
            if (!$scope.feature) {
                $scope.feature = {
                    slug: $scope.$stateParams.fslug
                };
                $scope.usePlanImage = true;
            }
        }
    });

}]);
